import { TweenMax } from 'gsap';
import toggleModal from '@/scripts/utils/toggle-modal';

class PopupPage {
  constructor(options) {
    this.popupContainerSelector = options.popupContainer;
    this.popupButtonSelector = options.popupButton;
  }

  toggleStatus() {
    const popup = document.querySelector(this.popupContainerSelector);

    if (popup.classList.contains('opened')) {
      popup.classList.remove('opened');

      const list = popup.querySelector('ul');
      if (list) {
        TweenMax.staggerFromTo(list.children, 1, {autoAlpha: 0, y: 30, ease: Power2.easeOut}, {
          autoAlpha: 1,
          y: 0,
          ease: Power2.easeOut,
        }, 0.15);
      }
    } else {
      popup.classList.add('opened');
    }

    return toggleModal(popup.classList.contains('opened'), this.popupButtonSelector);
  }

  init() {
    const popupBtn = document.querySelector(this.popupButtonSelector);
    if (!popupBtn) {
      return;
    }
    window.scrollTo(0, 1);

    popupBtn.addEventListener('click', (e) => {
      this.toggleStatus(e);
    }, false);
    document.addEventListener('scroll', () => {
      const position = window.pageYOffset;
      const cover = document.querySelector('.cover');

      if (!cover || cover.classList.contains('cover-slider_article')) {
        popupBtn.classList.add('is-scroll');
      } else {
        const coverH = cover.offsetHeight;

        if (position > coverH - 200) {
          popupBtn.classList.add('is-scroll');
        } else {
          popupBtn.classList.remove('is-scroll');
        }
      }
    });
  }
}

export default function initPopupPage(options) {
  const defaults = {
    popupContainer: '[data-type="popup-container"]',
    popupButton: '[data-type="popup-button"]',
  };
  const popupPage = new PopupPage(Object.assign({}, defaults, options));
  popupPage.init();
}



// WEBPACK FOOTER //
// ./scripts/elements/page-popup.js